<template>
  <div>
    <v-layout>
      <v-flex>
        <select-channel v-model="app" @changeChannel="loadData"></select-channel>
      </v-flex>
      <v-flex shrink>
        <v-btn v-if="$store.getters.getPackage != 'premium'" outline color="grey" class="ma-0 mb-1">
          <i class="fas fa-file-export mr-1"></i>
          {{ $t('export') }}
          <v-premium-lock
            text="Bring the data to excel for analysis. Upgrade to Premium onwards, starting at 500 baht/month."
          ></v-premium-lock>
        </v-btn>
        <v-btn
          v-else-if="$store.getters.getPackage == 'premium'"
          @click="exportdata"
          color="primary"
          outline
          class="ma-0 mb-1"
        >
          <i class="fas fa-file-export mr-1"></i>
          {{ $t('export') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <!-- Date filter -->
    <date-filter
      v-model="selectedDate"
      @changeFilter="onDateChanged"
      :default-filter="'last_7_days'"
    ></date-filter>
    <v-card class="mt-2" style="border-radius: 5px;">
      <v-card-text>
        <div style="position: relative; min-height: 400px">
          <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
          <template v-else-if="newusersSeries && !loading">
            <v-flex class="mb-4" v-if="dateRange.length > 1">
              <v-btn
                class="ma-0 mr-1 mb-1"
                depressed
                :outline="indexActive !== index"
                :color="indexActive === index ? 'primary' : 'grey'"
                small
                @click="onChangeLength(index)"
                v-for="(date, index) in dateRange"
                :key="`date-length-${index}`"
              >
                {{ date.name }} ({{ date.count }})
              </v-btn>
            </v-flex>
            <apexchart
              :key="timestamp"
              ref="newusers"
              type="bar"
              :options="newusersOptions"
              :series="newusersSeries"
              height="auto"
            ></apexchart>
          </template>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import SelectChannel from './SelectChannel'
import DateFilter from './DateFilter'
import VueApexCharts from 'vue-apexcharts'
import DashboardGraphLoading from './DashboardGraphLoading'
import api from '@/api'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import XLSX from 'xlsx'
export default {
  data() {
    return {
      dataReport: null,
      app: 'all',
      selectedDate: {
        start: dayjs()
          .subtract(7, 'days')
          .format('YYYY-MM-DD'),
        end: dayjs().format('YYYY-MM-DD')
      },
      loading: true,
      timestamp: dayjs().format('x'),
      newusersSeries: null,
      newusersOptions: {
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        yaxis: {
          type: 'datetime',
          categories: [],
          forceNiceScale: false,
          labels: {
            style: {
              margin: 20 // Adjust the margin to create space between labels
            }
          }

          // tickAmount: 1
          // labels: {
          //   style: {
          //     margin: 10 // Adjust the margin to create space between labels
          //   }
          // }
        },
        xaxis: {
          categories: []
        },
        legend: {
          position: 'bottom'
        },

        fill: {
          opacity: 1
        }
      },
      dates: [],
      dateItems: [],
      userItems: [],
      limit: 50,
      length: 1,
      dateRange: [],
      indexActive: 0
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  components: {
    SelectChannel,
    DateFilter,
    apexchart: VueApexCharts,
    DashboardGraphLoading
  },
  async mounted() {
    await this.loadData()
  },
  methods: {
    async loadData(e) {
      this.loading = true
      const response = await this.fetchData()
      this.dataReport = response.data
      let users = []
      let setDate = []
      let newusers = []
      let date = []
      this.dateRange = []

      const startDate = dayjs(this.selectedDate.start)
      const startMonth = startDate.get('month')
      const endDate = dayjs(this.selectedDate.end)

      const _start = dayjs(
        `${startDate.get('year').toString()}-${startDate
          .get('month')
          .toString()
          .padStart(2, '0')}-01`
      )
      const _end = dayjs(
        `${endDate.get('year').toString()}-${endDate
          .get('month')
          .toString()
          .padStart(2, '0')}-01`
      )
      const diff = Math.round(_end.diff(_start, 'month', true))

      if (diff < 0) {
        this.$swal.fire({
          title: `${this.$t('Unsuccessful')}`,
          text: this.$t('something_went_wrong'),
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          reverseButtons: true
        })
        this.loading = false
        return
      }

      if (
        e &&
        e.filter &&
        (['this_year', 'last_90_days', 'last_365_day'].includes(e.filter) ||
          (['custom_date'].includes(e.filter) && response.data.length > 31))
      ) {
        let currentMonth = startMonth
        let currentYear = startDate.get('year')

        for (let i = startMonth; i < startMonth + diff + 1; i++) {
          if (i > 11) {
            currentMonth = i - 12
          } else {
            currentMonth = i
          }

          if (i === 12) {
            currentYear++
          }

          users.push([
            {
              name: this.$t('total male'),
              data: []
            },
            {
              name: this.$t('total female'),
              data: []
            },
            {
              name: this.$t('total others'),
              data: []
            }
          ])
          setDate.push([])
          date.push([])
          let _date = dayjs(`${currentYear}-${(currentMonth + 1).toString().padStart(2, '0')}-01`)
          const endOfMonth = _date.daysInMonth()
          let count = 0
          for (let j = 0; j < endOfMonth; j++) {
            const currentDate = `${currentYear}-${(currentMonth + 1)
              .toString()
              .padStart(2, '0')}-${(j + 1).toString().padStart(2, '0')}`
            const findDate = response.data.find(
              item => dayjs(item.date).format('YYYY-MM-DD') === currentDate
            )
            if (findDate) {
              users[i - startMonth][0].data.push(findDate.total_male)
              users[i - startMonth][1].data.push(findDate.total_female)
              users[i - startMonth][2].data.push(findDate.total_others)
              date[i - startMonth].push(dayjs(findDate.date).format('YYYY-MM-DDTHH:00:00'))
              count += findDate.total_users
            } else {
              users[i - startMonth][0].data.push(0)
              users[i - startMonth][1].data.push(0)
              users[i - startMonth][2].data.push(0)
              date[i - startMonth].push(`${currentDate}T00:00:00`)
            }
            setDate[i - startMonth].push(dayjs(`${currentDate}T00:00:00`).format('DD-MM-YYYY'))
          }

          this.dateRange.push({
            index: i,
            name: `${(currentMonth + 1).toString().padStart(2, 0)} / ${currentYear}`,
            count: count.toLocaleString(),
            total: count
          })
        }
      } else {
        setDate.push([])
        date.push([])
        users.push([])

        for (let i = 0; i < response.data.length; i++) {
          const data = response.data[i]
          setDate[0].push(dayjs(data.date).format('DD-MM-YYYY'))
          date[0].push(dayjs(data.date).format('YYYY-MM-DDTHH:00:00'))
        }

        newusers = response.data.reduce(
          (prev, curr) => {
            prev[0].data.push(parseInt(curr.total_male))
            prev[1].data.push(parseInt(curr.total_female))
            prev[2].data.push(parseInt(curr.total_others))
            // total.push(
            //   parseInt(curr.total_female) + parseInt(curr.total_male) + parseInt(curr.total_others)
            // )
            return prev
          },
          [
            {
              name: this.$t('total male'),
              data: []
            },
            {
              name: this.$t('total female'),
              data: []
            },
            {
              name: this.$t('total others'),
              data: []
            }
          ]
        )
        users[0].push(...newusers)
      }

      this.newusersSeries = [...users[0]]
      this.userItems = [...users]
      this.dateItems = [...setDate]
      this.dates = [...date]
      this.loading = false

      await this.$nextTick()
      this.onSelectLength(0, true)
    },
    async onDateChanged(e) {
      await this.loadData(e)
    },
    async onChangeLength(index) {
      this.loading = true
      this.loading = false
      await this.$nextTick()
      await this.onSelectLength(index)
    },
    async onSelectLength(index, onload) {
      if (index === this.indexActive && !onload) return

      this.newusersSeries = [...this.userItems[index]]
      if (this.$refs.newusers) {
        this.$set(this.newusersOptions.yaxis, 'categories', this.dates[index])
        this.$set(this.newusersOptions.xaxis, 'categories', this.dateItems[index])

        this.$refs.newusers.updateOptions({
          yaxis: {
            type: 'datetime',
            categories: this.dates[index],
            forceNiceScale: false,
            labels: {
              style: {
                margin: 20 // Adjust the margin to create space between labels
              }
            }
          }
        })
      }
      this.indexActive = index
      await this.$nextTick()
      this.timestamp = dayjs().format('x')
    },
    fetchData() {
      var data = {
        params: {},
        body: {
          pageid: this.selectedBot.pageid,
          app: this.app,
          registertimestamp_from: dayjs(this.selectedDate.start).format('YYYY-MM-DD'),
          registertimestamp_to: dayjs(this.selectedDate.end).format('YYYY-MM-DD')
        }
      }
      return new Promise((resolve, reject) => {
        api.post_total_new_users(data, (error, response) => {
          if (error) reject(error)
          resolve(response)
        })
      })
    },
    exportdata() {
      var json = []
      const wb = XLSX.utils.book_new()
      var name = 'new-users.xlsx'
      json = this.dataReport
      const ws = XLSX.utils.json_to_sheet(json)
      wb.SheetNames.push('new-users')
      wb.Sheets['new-users'] = ws
      XLSX.writeFile(wb, name)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/NewUsers.vue